// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var PositionActionEnum;
(function (PositionActionEnum) {
    PositionActionEnum[PositionActionEnum["Unspecified"] = 0] = "Unspecified";
    PositionActionEnum[PositionActionEnum["All"] = 1] = "All";
    PositionActionEnum[PositionActionEnum["CLXAll"] = 2] = "CLXAll";
    PositionActionEnum[PositionActionEnum["CLXByAccountAndInstrument"] = 3] = "CLXByAccountAndInstrument";
    PositionActionEnum[PositionActionEnum["ByAccountAndInstrument"] = 4] = "ByAccountAndInstrument";
    PositionActionEnum[PositionActionEnum["ClosePositionMkt"] = 5] = "ClosePositionMkt";
    PositionActionEnum[PositionActionEnum["ClosePositionViaOE"] = 6] = "ClosePositionViaOE";
    PositionActionEnum[PositionActionEnum["Positive"] = 7] = "Positive";
    PositionActionEnum[PositionActionEnum["Negative"] = 8] = "Negative";
    PositionActionEnum[PositionActionEnum["Long"] = 9] = "Long";
    PositionActionEnum[PositionActionEnum["Short"] = 10] = "Short";
    PositionActionEnum[PositionActionEnum["ReverseByIds"] = 11] = "ReverseByIds";
    PositionActionEnum[PositionActionEnum["ReverseByInstrument"] = 12] = "ReverseByInstrument";
    PositionActionEnum[PositionActionEnum["ReverseAll"] = 13] = "ReverseAll";
    PositionActionEnum[PositionActionEnum["Mutual"] = 14] = "Mutual";
    PositionActionEnum[PositionActionEnum["PositionModifying"] = 15] = "PositionModifying";
    PositionActionEnum[PositionActionEnum["ModifyProductType"] = 16] = "ModifyProductType";
    PositionActionEnum[PositionActionEnum["ExerciseOption"] = 17] = "ExerciseOption";
    PositionActionEnum[PositionActionEnum["ExerciseCancelVisibility"] = 18] = "ExerciseCancelVisibility";
    PositionActionEnum[PositionActionEnum["ExerciseCancel"] = 19] = "ExerciseCancel";
})(PositionActionEnum || (PositionActionEnum = {}));
